import { createFileRoute, redirect } from "@tanstack/react-router";

// The Users page moved to Console; an old link lands on the applications list.
export const Route = createFileRoute("/users/")({
	beforeLoad: () => {
		throw redirect({
			to: "/applications",
			search: {
				search: "",
				startDate: "",
				endDate: "",
				page: 1,
				filterStatus: "",
				filters: {},
				tab: "single",
			},
			replace: true,
		});
	},
});
